import * as React from 'react';
import MuiMenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import { CommonPropsAndTypes } from '../_Types/StandardComponentProps';
import EDTooltip from '../Tooltip/EDTooltip';
// import { Theme } from '@mui/material/styles';

interface IProps {
  children?: React.ReactNode;
  value?: any;
  onClick?: React.MouseEventHandler<HTMLLIElement>;
  component?: React.ElementType<MenuItemProps> | 'div';
  selected?: boolean;
  key?: string | number;
  disabled?: boolean;
  disabledReason?: string;
  divider?: boolean;
  color?: CommonPropsAndTypes.ColorType;
  testId?: string;
  header?: boolean;
  heightSmall?: boolean;
}

const EDMenuItem: React.FC<IProps> = ({
  children,
  value,
  testId,
  disabled,
  disabledReason,
  header,
  selected,
  heightSmall,
  ...rest
}) => {
  const component = (
    <MuiMenuItem
      value={value}
      data-testid={testId}
      selected={selected}
      sx={{
        ...(header
          ? {
              '&.MuiMenuItem-root.Mui-disabled': { opacity: 1 },
              marginY: 0,
              marginX: -1,
            }
          : {}),
        ...(heightSmall ? { minHeight: 40 } : {}),
      }}
      disabled={disabled || header}
      {...rest}
    >
      {children}
    </MuiMenuItem>
  );

  if (disabled) {
    return (
      <EDTooltip title={disabledReason} enableClickOnTouch>
        <span
          onClick={e => {
            // To stop disabled menuitems from propagating clicks to parent
            e.stopPropagation();
          }}
        >
          {component}
        </span>
      </EDTooltip>
    );
  } else {
    return <>{component}</>;
  }
};

export default EDMenuItem;
